// extracted by mini-css-extract-plugin
export var assigneeBadge = "_kp-0";
export var assigneeDetails = "_kp-1";
export var assigneeInfo = "_kp-2";
export var dropdownContainer = "_kp-4";
export var dropdownImage = "_kp-5";
export var editAssigneeInfo = "_kp-3";
export var editAssigneeModalContainer = "_kp-6";
export var hidden = "_kp-8";
export var input = "_kp-7";